import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const Services = () => {
    return (
        <>
            <div className='services' id='services'>
                <h1>My Knowledges</h1>
                <div className="row serviceBox d-flex justify-content-center align-content-center">
                    <div className="boxing">
                        <FontAwesomeIcon className="icons" icon="fa-brands fa-html5" />
                        <h3>HTML5</h3>
                        <p className='servises-experience'>
                            <span>90%</span>
                        </p>
                        <p>Level</p>
                    </div>
                    <div className="boxing">
                        <FontAwesomeIcon className="icons" icon="fa-brands fa-css3-alt" />
                        <h3>CSS3</h3>
                        <p className='servises-experience'>
                            <span>90%</span>
                        </p>
                        <p>Level</p>
                    </div>
                    <div className="boxing">
                        <FontAwesomeIcon className="icons" icon="fa-brands fa-js" />
                        <h3>JavaScript</h3>
                        <p className='servises-experience javascript'>
                            <span></span>
                            <span>80%</span>
                        </p>
                        <p>Level</p>
                    </div>
                    <div className="boxing">
                        <FontAwesomeIcon className="icons" icon="fa-brands fa-react" />
                        <h3>React Js</h3>
                        <p className='servises-experience react'>
                            <span></span>
                            <span>60%</span>
                        </p>
                        <p>Level</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Services